export const TAXES = 0.97